export const columns = [
  {
    Header: 'Doca',
    id: 'dock',
    accessor: 'dock',
    width: 100,
    getProps: () => ({
      style: {
        fontSize: '24px',
        textAlign: 'center',
        fontWeight: 600,
      },
    }),
  },
  {
    Header: 'Fornecedor',
    id: 'supplier',
    accessor: 'supplier',
    getProps: (state, rowInfo) => ({
      style: {
        color:
          rowInfo && rowInfo.row.supplier === '** Livre **'
            ? '#9EABB9'
            : '',
      },
    }),
  },
  {
    Header: 'Início Recebimento',
    id: 'startReceivement',
    accessor: 'startReceivement',
    width: 200,
  },
  {
    Header: 'Tempo',
    id: 'time',
    accessor: 'time',
    width: 100,
  },
  {
    Header: 'Opções',
    id: 'options',
    accessor: 'options',
    width: 100,
  },
]
